type warn = {
    message: string;
    id: string;
}

interface IWarns {
    warns: warn[];
}

export default function WarnList({ warns }: IWarns) {
    return (
        <ul className='auth-warns'>
            {warns.map((e) => (
                <li key={e.id + e.message}>{e.message}</li>
            ))}
        </ul>
    )
}